import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IconCaret from "../../assets/IconCaret";
// Styles
import "../../assets/saas/molecules/_blue-bar.scss";
const BlueBar = ({ onclick, customId, t, customClass }) => {
    return (_jsx("div", { className: `blue-bar ${customClass}`, id: customId, style: { display: customId === "blue-bar-searchbar" ? 'none' : '' }, children: _jsxs("div", { className: "main-back-blue-bar", onClick: () => {
                onclick();
            }, children: [_jsx(IconCaret, {}), _jsx("p", { children: t("modal-back-blue-bar") })] }) }));
};
export default BlueBar;
